import { rootSagaFactory } from '../importer/sagas';
import { EImportEntity } from '../importer/model';

import { ancillaryTransfersImportDomainSelector } from './selectors';

export default rootSagaFactory({
  entity: EImportEntity.ANCILLARY_TRANSFERS,
  domainSelector: ancillaryTransfersImportDomainSelector,

  importApiCall: (backendApi, bookingManagerApi) => bookingManagerApi.postImportAncillaryTransfers(),

  importStatusApiCall: async (backendApi, bookingManagerApi) => {
    const result = await bookingManagerApi.getImportAncillaryTransfersStatus();

    // massage the result into the expected shape
    return {
      ...result,
      data: {
        ...result.data,
        meta: {
          workbookId: result.data.workbookId,
        },
        data: {
          ...result.data,
        },
      },
    };
  },
});
